var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"performance-right-chart-container"},[_c('div',[_vm._v(" 当前 "),_c('div',{staticClass:"performance-chart",attrs:{"id":_vm.currentChartId}})]),_c('div',{staticStyle:{"margin-top":"1px"}},[_vm._v(" 同比 "),_c('div',{staticClass:"performance-chart",attrs:{"id":_vm.compareChartId}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }